import React from 'react';
import { Modal, HelpButton } from '@placer-ui/components';

interface TitleModalHeaderProps {
    title: string;
    subTitle?: string;
    elevioId?: number;
}

export const TitleModalHeader = ({ title, subTitle, elevioId }: TitleModalHeaderProps) => {
    return (
        <Modal.Header>
            <Modal.Header.Info headerVariant="first" title={title} description={subTitle} />
            <Modal.Header.Actions hasCloseButton>
                {elevioId && (
                    <HelpButton
                        size={'large'}
                        tooltip={'Learn more'}
                        data-elevio-inline={elevioId}
                        data-elevio-style={'nothing'}
                        testId={'title-modal-header-elevio'}
                        appendToParent
                    />
                )}
            </Modal.Header.Actions>
        </Modal.Header>
    );
};
